export default "__VITE_ASSET__RXN$HlgQ__"